import { useEffect, useState } from 'react';
import { FaArrowLeft, FaPlus, FaSave, FaTag, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import productService from '../../utils/productService';

const CustomerWaitlistForm = ({ onSubmit, onCancel }) => {
  const [products, setProducts] = useState([]);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [productId, setProductId] = useState('');
  const [requiredQuantity, setRequiredQuantity] = useState(1);

  useEffect(() => {
    productService.getAll().then((response) => setProducts(response.data || [])).catch(() => setProducts([]));
  }, []);

  const submit = (e) => {
    e.preventDefault();
    const pid = productId ? Number(productId) : null;
    const product = pid ? products.find((p) => p.id === pid) : null;
    if (!product) return;

    onSubmit({
      name: String(name || '').trim(),
      email: String(email || '').trim(),
      phone: String(phone || '').trim(),
      address: String(address || '').trim(),
      product_id: product.id,
      product_name: product.name,
      required_qty: Math.max(1, Number(requiredQuantity) || 1),
    });
  };

  const canSubmit = name.trim().length > 0 && productId;

  return (
    <form onSubmit={submit} className="space-y-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaUser className="text-sky-500" /> Name
          </label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200"
            required
          />
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaPhone className="text-emerald-500" /> Phone
          </label>
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200"
            placeholder="e.g. 0300-1234567"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaEnvelope className="text-indigo-500" /> Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200"
            placeholder="name@example.com"
          />
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaMapMarkerAlt className="text-fuchsia-500" /> Address
          </label>
          <input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200"
            placeholder="Street, City"
          />
        </div>
      </div>

      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="md:col-span-2">
            <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
              <FaTag className="text-amber-500" /> Product
            </label>
            <select
              value={productId}
              onChange={(e) => setProductId(e.target.value)}
              className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200"
              required
            >
              <option value="">Select product</option>
              {products.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
              <FaPlus className="text-teal-600" /> Required Qty
            </label>
            <input
              type="number"
              min="1"
              value={requiredQuantity}
              onChange={(e) => setRequiredQuantity(Number(e.target.value))}
              className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <button
          type="submit"
          disabled={!canSubmit}
          className="inline-flex items-center justify-center gap-2 rounded-md bg-[#00595A] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#004446] disabled:cursor-not-allowed disabled:opacity-50"
        >
          <FaSave className="h-4 w-4" /> Add to waitlist
        </button>
        {onCancel ? (
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-slate-100 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200"
          >
            <FaArrowLeft className="h-4 w-4" /> Back
          </button>
        ) : null}
      </div>
    </form>
  );
};

export default CustomerWaitlistForm;
